export const manifest = {
  screens: {
    scr_vq2e4r: { name: "Home", route: "/", position: {"x":160,"y":5780} },
    scr_fac339: { name: "Book — Select Service", route: "/book", state: {"step":1}, position: {"x":160,"y":1820} },
    scr_6fnob7: { name: "Book — Select Date", route: "/book", state: {"step":2}, position: {"x":1560,"y":1820} },
    scr_6fdpc6: { name: "Book — Select Time", route: "/book", state: {"step":3}, position: {"x":2960,"y":1820} },
    scr_clqpms: { name: "Book — Patient Info", route: "/book", state: {"step":4}, position: {"x":4360,"y":1820} },
    scr_sz4rjr: { name: "Book — Confirmation", route: "/book", state: {"step":5}, position: {"x":5760,"y":1820} },
    scr_ynmlts: { name: "About Us", route: "/about", position: {"x":160,"y":3800} },
    scr_pkr0ol: { name: "Services", route: "/services", position: {"x":1560,"y":3800} },
    scr_2tpvii: { name: "Service Detail", route: "/services/general-medical-consultations", position: {"x":9960,"y":3800} },
    scr_8fdnjd: { name: "Patient Information", route: "/patient-information", position: {"x":2960,"y":3800} },
    scr_jqkoie: { name: "Doctors & Staff", route: "/doctors", position: {"x":4360,"y":3800} },
    scr_1kybkl: { name: "Facilities", route: "/facilities", position: {"x":5760,"y":3800} },
    scr_pwkwzq: { name: "Blog", route: "/blog", position: {"x":7160,"y":3800} },
    scr_whqaos: { name: "Blog Article", route: "/blog/1", position: {"x":12760,"y":3800} },
    scr_wn4ymz: { name: "FAQ", route: "/faq", position: {"x":11360,"y":3800} },
    scr_e4tm6s: { name: "Contact", route: "/contact", position: {"x":8560,"y":3800} },
    scr_e06vje: { name: "Privacy Policy", route: "/privacy", position: {"x":160,"y":7760} },
    scr_kwtuoo: { name: "Terms of Service", route: "/terms", position: {"x":1560,"y":7760} },
    scr_uvj55m: { name: "CSR Initiatives", route: "/csr-initiatives", position: {"x":14160,"y":3800} },
  },
  sections: {
    sec_plpv9u: { name: "Booking Flow", x: 0, y: 1600, width: 7120, height: 1180 },
    sec_wsq9gv: { name: "Information Pages", x: 0, y: 3580, width: 15520, height: 1180 },
    sec_qn9v0g: { name: "Landing", x: 0, y: 5560, width: 1520, height: 1180 },
    sec_4na2n3: { name: "Legal Pages", x: 0, y: 7540, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_plpv9u", children: [
      { kind: "screen", id: "scr_fac339" },
      { kind: "screen", id: "scr_6fnob7" },
      { kind: "screen", id: "scr_6fdpc6" },
      { kind: "screen", id: "scr_clqpms" },
      { kind: "screen", id: "scr_sz4rjr" },
    ] },
    { kind: "section", id: "sec_wsq9gv", children: [
      { kind: "screen", id: "scr_ynmlts" },
      { kind: "screen", id: "scr_pkr0ol" },
      { kind: "screen", id: "scr_8fdnjd" },
      { kind: "screen", id: "scr_jqkoie" },
      { kind: "screen", id: "scr_1kybkl" },
      { kind: "screen", id: "scr_pwkwzq" },
      { kind: "screen", id: "scr_e4tm6s" },
      { kind: "screen", id: "scr_2tpvii" },
      { kind: "screen", id: "scr_wn4ymz" },
      { kind: "screen", id: "scr_whqaos" },
      { kind: "screen", id: "scr_uvj55m" },
    ] },
    { kind: "section", id: "sec_qn9v0g", children: [
      { kind: "screen", id: "scr_vq2e4r" },
    ] },
    { kind: "section", id: "sec_4na2n3", children: [
      { kind: "screen", id: "scr_e06vje" },
      { kind: "screen", id: "scr_kwtuoo" },
    ] },
  ],
}
